import { useCallback, useState } from 'react';
import { useMedia } from 'react-use';
import Cookies from 'js-cookie';

import { isAutotestUserAgent } from '../../utils/is-autotest-user-agent';
import { isBrowser } from '../../utils/is-browser';
import { isSmartAppBannerDismissed, persistSmartAppBannerDismissedAt } from './storage';
import { shouldShowSmartAppBanner, SmartAppBannerLayoutType } from './visibility';

const XS_QUERY = '(max-width: 767px)';
const WEBVIEW_COOKIE = 'is_webview_client';

export const useSmartAppBanner = ({
    pathname,
    layoutType,
    enabled = true,
}: {
    pathname: string;
    layoutType: SmartAppBannerLayoutType;
    enabled?: boolean;
}) => {
    // default false: SSR и первый клиентский кадр совпадают, media обновляется в effect
    const isXs = useMedia(XS_QUERY, false);
    const [isDismissed, setIsDismissed] = useState(() => isSmartAppBannerDismissed());

    const isVisible =
        enabled &&
        shouldShowSmartAppBanner({
            isXs,
            pathname,
            layoutType,
            isWebview: Cookies.get(WEBVIEW_COOKIE) === 'true',
            isDismissed,
            isAutotest: isBrowser() && isAutotestUserAgent(navigator.userAgent),
        });

    const dismiss = useCallback(() => {
        persistSmartAppBannerDismissedAt();
        setIsDismissed(true);
    }, []);

    return { isVisible, dismiss };
};
